// TODO: remove when the European market opening period ends; copy for the locked-state popup
export const LOCKED_SUBSCRIBE_TITLE = 'Commentary & Deal Flow (Real-Time)';

export const LOCKED_SUBSCRIBE_DESCRIPTION = 'Commentary & deal flow is offered at an additional cost. '
  + 'Please contact us for further pricing details and access.';
